export enum LocalStorageKeys {
    PrivacyPolicy = 'por_privacy_policy_accepted'
}
